/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { p as promiseWindVane } from '../../promise-windvane-85486cec.js';
import { c as call } from '../../index.es-142c5680.js';
import { c as isNebula } from '../../index-f24a9ec1.js';
import { JSCall } from '../../bridges/dd/index.js';
import { env } from '../env/index.js';
import '../../index-6f6b9acc.js';
import { l as loadScripts } from '../../loadscripts-cf212b8d.js';
import { B as BRIDGE_DEPEND_LIBS } from '../../constants-163bd007.js';
import '../../bridges/windvane/index.js';
import '../../bridge-adpter-api-0316c034.js';
import '../../tslib.es6-e01eabb2.js';
import '../../index-892d8eee.js';
import '../../_commonjsHelpers-56d33373.js';

/**
 * @description nebula promise
 * @param apiName 方法名
 * @param params 其他参数
 */
var promiseNebule = function (apiName, params) {
    return new Promise(function (resolve) {
        if (!isNebula) {
            resolve({ success: false, data: null, message: 'no nebula found' });
        }
        try {
            call(apiName, params, function (res) {
                resolve({ success: true, data: res });
            }, function (e) {
                resolve({ success: false, message: e.message });
            });
        }
        catch (e) {
            resolve({
                success: false,
                message: e instanceof Error ? e.message : 'expectation failed',
            });
        }
    });
};

/**
 * @description dingTalk promise
 * @param api 方法名。如'biz.util.share'
 * @param params 参数
 */
var promiseDingTalk = function (api, params) {
    return new Promise(function (resolve) {
        var excuteDingTalkBridge = function () {
            try {
                JSCall(api, params, function (res) {
                    resolve({ success: true, data: res });
                }, function (e) {
                    resolve({ success: false, message: e === null || e === void 0 ? void 0 : e.message });
                });
            }
            catch (e) {
                resolve({
                    success: false,
                    message: e instanceof Error ? e.message : 'expectation failed',
                });
            }
        };
        if (!env.isDingTalk) {
            resolve({ success: false, message: 'not dingTalk app' });
            return;
        }
        if (typeof dd === 'undefined') {
            loadScripts(BRIDGE_DEPEND_LIBS.dingTalk)
                .then(function () {
                excuteDingTalkBridge();
            })
                .catch(function () {
                resolve({ success: false, message: 'dd lib script not download' });
            });
            return;
        }
        excuteDingTalkBridge();
    });
};

var resolvedJsbridge = function (promise) {
    return promise
        .then(function (res) {
        return Promise.resolve({
            success: true,
            data: res,
        });
    })
        .catch(function (err) {
        return Promise.resolve({
            success: false,
            data: err,
        });
    });
};

/**
 * 方便的对外工具函数。
 * 类似node utils.promisify，有需要则使用。包含：
 * 1. 底层web容器调用：promiseWindvane、promiseNebula
 * 2. resolvedJsbridge。把promise的reject，转换为 promise 的resolve { success: false }形态
 */
var utils = {
    /**
     * windvane容器 call。等同于window.Windvane.call() 的Promise版。
     * @see https://h5.alibaba-inc.com/api/WindVane-API.html
     *
     * @example 使用案例：
     * import { promiseWindvane } from '@alife/cn-uni-api'; // h5、小程序通用包
     *
     * const res = await utils.promiseWindvane('Base', 'copyToClipboard', {})
     * if (res.success) {
     *  console.log('success', res.data);
     * } else {
     *  console.log('fail');
     * }
     *
     * @author 敬文
     */
    promiseWindVane: promiseWindVane,
    /**
     * nebula容器 call。等同于window.AlipayJSBridge.call() 的Promise版。
     * @see https://smallfish.antfin-inc.com/jsapi/chooseImage.html
     *
     * @example 使用案例：
     * import { promiseNebule } from '@alife/cn-uni-api'; // h5、小程序通用包
     *
     * const res = await utils.promiseNebule('copyToClipboard', {})
     * if (res.success) {
     *  console.log('success', res.data);
     * } else {
     *  console.log('fail');
     * }
     *
     * @author 敬文
     */
    promiseNebule: promiseNebule,
    /**
     * 钉钉容器 call。等同于window.dd.call() 的Promise版。
     * API会自动按需引入钉钉官方jssdk，无需用户手动引入。
     * @see https://open.dingtalk.com/document/orgapp-client/jsapi-overview
     *
     * @example 使用案例：
     * import { promiseDingTalk } from '@alife/cn-uni-api'; // h5、小程序通用包
     *
     * const res = await utils.promiseDingTalk('biz.util.share', { url: 'http://xxx' })
     * if (res.success) {
     *  console.log('success', res.data);
     * } else {
     *  console.log('fail');
     * }
     *
     * @author 敬文
     */
    promiseDingTalk: promiseDingTalk,
    /**
     * 把promise的reject，转换为 promise 的resolve { success: false }形态。
     *
     * @example 使用案例：
     * import { utils, showToast } from '@alife/cn-uni-api'; // h5、小程序通用包
     *
     * const promise = showToast({ duration: 1000 });
     * const res = await utils.resolvedJsbridge(promise);
     * if (res.success) {
     *  console.log('success', res.data);
     * } else {
     *  console.log('fail');
     * }
     *
     * @author 敬文
     */
    resolvedJsbridge: resolvedJsbridge,
};

export { utils };
